import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigServerService, CustomHttp } from '../../../../core';

@Injectable({
    providedIn: 'root'
})
export class PedidoValidacoesHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/pedido`;
    }

    /** Obtem o valor total de vendas do representante no período para as validações das bonificações */
    getValorVendaMesValidacaoBonificacao(idPeriodo: number, idRepresentante: number): Observable<number> {
        // Params
        let params = new HttpParams()
        // Período
        params = params.append('idPeriodo', idPeriodo ? idPeriodo.toString() : null);
        // Representante
        params = params.append('idRepresentante', idRepresentante ? idRepresentante.toString() : null);

        return this.customHttp.get<number>(`${this.pathApi}/0/validacao/bonificacao/valorvendames`, {params});
    }
}
